import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const textAndImageDarkInit = () => {
    const modules = document.querySelectorAll('.gg-text-and-image');
    modules.forEach((module) => {
        const groupImage = module.querySelector('.wp-block-media-text__media');
        const smallInfoBox = module.querySelector('.gg-text-and-image__small-info-box');
        const imagePlus = module.querySelector('.gg-text-and-image__plus-background');
        const groupContentImage = document.createElement('div');
        groupContentImage.classList.add('gg-text-and-image__group-content-image');
        
        if (groupImage && smallInfoBox) {
            const groupBlockImage = document.createElement('div');
            groupBlockImage.classList.add('gg-text-and-image__group-block-image');
            groupImage.parentNode.insertBefore(groupContentImage, groupImage);
            groupContentImage.appendChild(groupBlockImage);
            imagePlus.style.opacity = '1';
            groupBlockImage.appendChild(imagePlus);
            groupBlockImage.appendChild(groupImage);
        } else {
            module.querySelector('.wp-block-media-text').classList.add('gg-non-small-info')
        }

        if (smallInfoBox && smallInfoBox) {
            smallInfoBox.style.opacity = '1';
            groupContentImage.appendChild(smallInfoBox);
        }
    });
};

Gravity.ready(textAndImageDarkInit);
